export class PaymentServiceModel {
    CustomerEmail: string;
    Description: string;
    Amount: number;

    constructor(
        CustomerEmail: string,
        Description: string,
        Amount: number
    ) {
        this.CustomerEmail = CustomerEmail;
        this.Description = Description;
        this.Amount = Amount;
    }
}

